import React, { useState } from 'react';
import { Alert, Button, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import Dialog from './ActionDialog';
import { useTranslation } from 'react-i18next';
import { submitFeedback } from '../services/FeedbackService';

export default function FeedbackDialog({ open, onClose, roomId }) {
    const { t } = useTranslation();
    const [message, setMessage] = useState('');
    const [busy, setBusy] = useState(false);
    const [result, setResult] = useState('');
    const send = async event => {
        event.preventDefault(); if (busy || !message.trim()) return;
        setBusy(true); setResult('');
        try { await submitFeedback(message.trim(), roomId); setMessage(''); setResult('sent'); }
        catch { setResult('failed'); }
        finally { setBusy(false); }
    };
    return <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="sm" aria-labelledby="feedback-title"
        PaperProps={{ component: 'form', onSubmit: send }}>
        <DialogTitle id="feedback-title">{t('feedback.title')}</DialogTitle>
        <DialogContent>
            {result && <Alert severity={result === 'sent' ? 'success' : 'error'} sx={{ mb: 2 }}>{t(`feedback.${result}`)}</Alert>}
            <TextField autoFocus fullWidth multiline minRows={4} maxRows={8} required label={t('feedback.message')}
                value={message} disabled={busy} onChange={event => { setMessage(event.target.value); setResult(''); }}
                inputProps={{ maxLength: 2000 }} helperText={`${message.length}/2000`} />
        </DialogContent>
        <DialogActions><Button disabled={busy} onClick={onClose}>{t('common.close')}</Button>
            <Button type="submit" variant="contained" disabled={busy || !message.trim()}>{t('feedback.send')}</Button></DialogActions>
    </Dialog>;
}
